import { useState } from 'react'
import { toast } from 'react-toastify'
import { API, API_ROUTER } from '../../../../../../../api'

const useFollowHandler = (id, name, follow) => {
  const [star, setStar] = useState(!follow)

  const followHandler = async () => {
    try {
      const followStatus = await API.request({
        ...API_ROUTER.follow.IsUserFollowCommunity,
        pathKeys: {
          communityId: id,
        },
      })

      if (followStatus.follow === true) {
        try {
          await API.request({
            ...API_ROUTER.follow.stopFollowCommunity,
            pathKeys: {
              communityId: id,
            },
          })
          toast.success(`You unfollowed ${name}`)
        } catch (error) {
          console.error('Unfollow error:', error)
          toast.error('Failed to unfollow community')
        }
      } else {
        try {
          await API.request({
            ...API_ROUTER.follow.followCommunity,
            data: {
              communityId: id,
            },
          })
          toast.success(`You followed ${name}`)
        } catch (error) {
          console.error('Follow error:', error)
          toast.error('Failed to follow community')
        }
      }
    } catch (error) {
      console.error('Follow check error:', error)
      toast.error('Failed to check follow status')
    }

    if (star) {
      setStar(false)
    } else {
      setStar(true)
    }
  }

  return { star, followHandler }
}

export default useFollowHandler
